export const APP_MODE = WEBPACK_APP_MODE;
export const PROJECT_PREFIX = '/contentmanager';
export const CONTENT_DOMAIN = '//vkplay.ru/';
export const API_DOMAIN = '/admin_api/';
export const GAMES_URL = '/pc/games/';
export const PUBLIC_DOMAINS = {
    production: 'https://media.vkplay.ru',
    development: `https://${window.location.host.split('-')[0]}-media.gm3.dev-vkplay.ru`,
    stage: 'https://media.dev-vkplay.ru',
};
export const PUBLIC_DOMAINS_APP = {
    production: 'https://vkplay.ru/media',
    development: `https://${window.location.host.split('-')[0]}-store.gm3.dev-vkplay.ru/media`,
    stage: 'https://store.dev-vkplay.ru/media',
};
export const PUBLIC_DOMAIN = PUBLIC_DOMAINS[APP_MODE];
export const PUBLIC_DOMAIN_APP = PUBLIC_DOMAINS_APP[APP_MODE];

export const VIDEO_TYPES = [
    { id: 'trailer', name: 'Трейлер' },
    { id: 'gameplay', name: 'Геймплей' },
    { id: 'advert', name: 'Реклама' },
    { id: 'spec', name: 'Спец' },
    { id: 'review', name: 'Наше видео' },
];

export const TAG_TYPES = [
    { id: 'mod', name: 'Мод' },
    { id: 'company', name: 'Компания' },
    { id: 'platform', name: 'Платформа' },
    { id: 'game_mode', name: 'Режим игры' },
];

export const ENT_TYPES = [
    { id: 'hard', name: 'Железо и софт' },
    { id: 'preview', name: 'Превью' },
    { id: 'review', name: 'Обзор' },
    { id: 'feat', name: 'Статья' },
    { id: 'secret', name: 'Секрет' },
    // {'id': 'story', 'name': 'Материал при поддержке'},
    // {'id': 'faq', 'name': 'F.A.Q.'},
    { id: 'news', name: 'Новости' },
    // {'id': 'video', 'name': 'Видео'},
    // {'id': 'compilation', 'name': 'Подборка'},
    { id: 'commercial', name: 'Коммерческие материалы' },
    { id: 'file', name: 'Моды' },
];

export const PROJECT_DOMAINS = [
    { id: 'media.vkplay.ru', name: 'VK Play' },
];

export const PROJECT_ICONS = {
    'media.vkplay.ru': 'https://vkplay.ru/hotbox/content_files/media/1652863578_vkplay.svg',
    'gof.vkplay.ru': 'https://vkplay.ru/hotbox/content_files/media/1692891882_gof.svg',
};

export const STATUSES = {
    draft: {
        label: 'В работе',
        color: '#fa5252',
    },
    moderation: {
        label: 'На модерации',
        color: '#4060c0',
    },
    published: {
        label: 'Опубликовано',
        color: '#40c057',
    },
};

export const hosts = {
    'media.vkplay.ru': {
        dev: process.env.VK_PLAY_MEDIA_DEV,
        prod: 'https://media.vkplay.ru',
        label: 'Media',
        icon: 'https://vkplay.ru/hotbox/content_files/media/1652863578_vkplay.svg',
    },
    'gof.vkplay.ru': {
        dev: process.env.GOF_MEDIA_DEV,
        prod: 'https://media.vkplay.ru',
        label: 'GoF',
        icon: 'https://vkplay.ru/hotbox/content_files/media/1692891882_gof.svg',
    },
};
